module.exports = __webpack_public_path__ + "static/client13-3a004172b08f76f7dd891ac677e87d16.png";